<template>
  <div class="line-card-preview">
    <v-card elevation="2" rounded="lg" class="overflow-hidden">
      <!-- Header -->
      <v-card-title class="line-card-header white--text">
        {{ mockData.clinicName }}改約通知
      </v-card-title>

      <!-- 內容區 -->
      <v-card-text class="pa-6">
        <!-- 病人資訊 -->
        <v-row v-for="(item, index) in patientInfo" :key="'info-' + index" no-gutters class="mb-2">
          <v-col cols="5" class="text-body-2 grey--text text--darken-1">{{ item.label }}</v-col>
          <v-col cols="7" class="text-body-2">{{ item.value }}</v-col>
        </v-row>

        <v-divider class="my-4" />

        <!-- 改約原因與聯繫選項 -->
        <v-row no-gutters class="mb-2">
          <v-col cols="5" class="text-body-2 grey--text text--darken-1">改約原因：</v-col>
          <v-col cols="7" class="text-body-2">
            <strong>{{ selectedReason }}</strong>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="5" class="text-body-2 grey--text text--darken-1">是否聯繫：</v-col>
          <v-col cols="7" class="text-body-2">
            <strong>{{ selectedContact }}</strong>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- 按鈕區 -->
      <v-card-actions class="flex-column pa-6 pt-0">
        <v-btn
          v-for="(btn, index) in buttons"
          :key="index"
          :outlined="btn.outlined"
          :color="btn.color"
          block
          large
          class="mb-3 rounded-lg"
        >
          {{ btn.text }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'LineCardPreview',

  props: {
    mockData: {
      type: Object,
      default: () => ({})
    },
    selectedReason: {
      type: String,
      default: ''
    },
    selectedContact: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      buttons: [
        { text: '查看改約清單', color: 'tiffany-10', outlined: true },
        { text: '已更換時間', color: 'tiffany-10', outlined: true },
        { text: '病人點擊錯誤', color: 'grey', outlined: true }
      ]
    }
  },

  computed: {
    patientInfo() {
      return [
        { label: '病人姓名：', value: this.mockData.patientName || '' },
        { label: '原訂時間：', value: `${this.mockData.appointmentDate} ${this.mockData.appointmentTime}` },
        { label: '點擊更改時間：', value: this.mockData.clickTime || '' },
        { label: '預約醫師：', value: this.mockData.doctorName || '' },
        { label: '診所備註：', value: this.mockData.clinicNote || '' }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.line-card-preview {
  max-width: 390px;
  width: 100%;
}

.line-card-header {
  background: var(--v-tiffany-10-base, #00D4B4);
  font-size: 18px;
  font-weight: 500;
}

</style>
